import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import { Button } from 'antd';
import { CheckOutlined, BellOutlined, LinkOutlined } from '@ant-design/icons';

const useStyles = makeStyles(theme => ({
  container: {
    position: 'relative',
    height: 160,
    padding: 24,
    borderRadius: 2,
    border: '1px solid rgba(0, 0, 0, 0.06)',
    backgroundColor: theme.colors.gray1,
    marginBottom: 16,
  },
  publishContainer: {
    borderLeft: `3px solid ${theme.colors.mainGreen6}`,
  },
  draftContainer: {
    borderLeft: `3px solid ${theme.colors.orange6}`,
  },
  title: {
    ...theme.typography.h4,
    color: theme.colors.titleColor,
    marginBottom: 8,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  content: {
    ...theme.typography.body2,
    color: theme.colors.bodyColor,
    marginBottom: 14,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
  },
  footer: {
    position: 'absolute',
    bottom: 24,
    display: 'flex',
    alignItems: 'center',
    color: theme.colors.captionColor,
  },
  dateText: {
    ...theme.typography.body2,
    paddingLeft: 6,
  },
  dotSpan: {
    width: 4,
    height: 4,
    margin: '0 12px',
    borderRadius: 4,
    backgroundColor: theme.colors.disableColor,
  },
  numSpan: {
    paddingLeft: 4,
  },
  viewBtn: {
    height: 22,
    padding: 0,
  },
  delBtn: {
    height: 22,
    padding: 0,
    color: theme.colors.red11,

    '&:hover': {
      color: theme.colors.red11,
    },
  },
}));

import { PUBLISHED, DRAFT } from '../modal';

const Card = ({ data, handleViewClick, handleRemoveClick }) => {
  const { title, status, content, article, publishedAt } = data;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div
      className={classNames(classes.container, {
        [classes.publishContainer]: status === PUBLISHED,
        [classes.draftContainer]: status === DRAFT,
      })}
    >
      <h4 className={classes.title}>{title}</h4>
      <p className={classes.content}>{content}</p>
      <div className={classes.footer}>
        <div className={classes.status}>
          <Choose>
            <When condition={status === PUBLISHED}>
              <CheckOutlined style={{ fontSize: 12 }} />
              <span className={classes.dateText}>{`${t(
                'content.release_note.published.text',
              )} ${publishedAt}`}</span>
            </When>
            <Otherwise>
              <BellOutlined style={{ fontSize: 12 }} />
              <span className={classes.dateText}>{`${t(
                'content.release_note.draft.text',
              )} ${publishedAt}`}</span>
            </Otherwise>
          </Choose>
        </div>
        <If condition={article}>
          <span className={classes.dotSpan} />

          <LinkOutlined />

          <span className={classes.numSpan}>1</span>
        </If>
        <span className={classes.dotSpan} />
        <Button type="link" className={classes.viewBtn} onClick={() => handleViewClick(data)}>
          {t('content.release_note.btn.view')}
        </Button>
        <span className={classes.dotSpan} />
        <Button type="link" className={classes.delBtn} onClick={() => handleRemoveClick(data.id)}>
          {t('content.release_note.btn.delete')}
        </Button>
      </div>
    </div>
  );
};

export default Card;
